<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        :reduced="data.reduced"
        >
        <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters v-if="!data.reduced">
            <!-- componente a parte ha flag obbligatorio -->
                <v-radio-group class="pa-0 ma-0 d-flex flex-grow-1 flex-shrink-0" disabled v-model="measures.zero_device" label="Mantenimento dello zero">
                    <v-radio label="Attivo" value="on"></v-radio>
                    <v-radio label="Disattivo" value="off"></v-radio>
                    <v-radio label="Fuori zona intervento" value="out"></v-radio>
                </v-radio-group>
                <!-- componente a parte ha flag obbligatorio e meccanico-->
                <v-radio-group v-if="notMechanical" class="pa-0 ma-0 d-flex flex-grow-1 flex-shrink-0" :disabled="preview" v-model="measures.hi_res" label="Alta risoluzione">
                    <v-radio label="Attivo" value="on"></v-radio>
                    <v-radio label="Disattivo" value="off"></v-radio>
                </v-radio-group>
            </v-row>
            <v-row no-gutters >
                <v-alert class="d-flex flex-shrink-1 flex-grow-0"  v-if="enoughPrimaries" type="error" :value="true">
                    Masse campione selezionate insufficienti
                </v-alert>
                <v-autocomplete v-else 
                    dense outlined
                    class="d-flex flex-shrink-1 flex-grow-0" 
                    :disabled="preview"
                    label="% masse campione/portata"
                    :items="computedCapacities"
                    v-model="measures.capacity"
                    item-text="text"
                    item-value="val"
                    autocomplete
                    @input="changeCapacity"
                ></v-autocomplete>
                <v-text-field
                    dense outlined
                    class="pl-4 d-flex flex-shrink-1 flex-grow-0"
                    label="Totale masse campione a seguito"
                    v-model="calculateTotal"
                    disabled
                    suffix="kg"
                ></v-text-field>
                <div class="d-flex flex-shrink-0 flex-grow-1 justify-end py-2" v-if="!preview">
                    <v-btn @click="updateLinearity()" v-if="checkResult" color="primary">Aggiorna linearità</v-btn>
                    <v-btn class="ml-2" @click="convertPlaceholders(measures.items)" color="primary">Riempimento automatico</v-btn>
                </div>
            </v-row>
            <v-row no-gutters>
            <v-simple-table class="measure_table">
                <template v-slot:default>
                    <thead class="expansion">
                    <tr>
                        <th class="table-text-blocks text-center">{{data.block.conf.headers.rif}}</th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.addLoad}}</th>
                        <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.p}}</th>
                    </tr>
                    </thead>
                    <tr v-for="(item,index) of measures.items" :key="index" class="align-end justify-center fill-height">
                        <td class="table-blocks d-flex align-center">
                            <v-icon class="d-flex flex-shrink-1 flex-grow-0" v-if="index >= conf.min_readings && !preview" @click="removeRow(index)">delete</v-icon>
                            <div v-else class="d-flex mr-6"></div>
                            <div class="d-flex justify-center flex-shrink-0 flex-grow-1">{{ index + 1 }}</div>
                        </td>
                        <td class="table-blocks" :rowspan="measures.items.length" v-if="index==0">
                            <NumericField dense outlined
                                @input="changeMass()"
                                solo hide-details
                                :readonly="preview"
                                v-model="measures.mass"
                                :precision="currentPrecision"
                                :negative="false"
                                :class="readingWarning(measures.mass)"
                            ></NumericField> 
                        </td>
                        <td class="table-blocks">
                            <NumericField dense outlined
                                @input="changeReading(item)"
                                solo hide-details
                                :readonly="preview"
                                v-model="item.reading"
                                :precision="currentPrecision"
                                :negative="false"
                                :placeholder="readingPlaceholder(item.mass)"
                                :class="readingWarning(item.reading)"
                                :enableicons="!preview"
                                :addfunc="readingAddFunc"
                                :subfunc="readingSubFunc"
                                :row="item"
                                :fieldname="'reading'"
                                :range="calcMinRange(item.reading)"
                            ></NumericField> 
                        </td>
                        <td v-if="measures.hi_res=='off'" class="table-blocks">
                            <NumericField dense outlined
                                @input="changeAddLoad(item)"
                                solo hide-details
                                :readonly="preview"
                                v-model="item.addLoad"
                                :precision="high_precision"
                                :negative="false"
                                :placeholder="calculateAddLoadPlaceholder(item.reading)"
                                :class="addLoadWarning(item.addLoad, item.reading)"
                                :enableicons="!preview"
                                :addfunc="loadAddFunc"
                                :subfunc="loadSubFunc"
                                :row="item"
                                :fieldname="'addLoad'"
                                :range="calcMinRange(item.reading)"
                            ></NumericField>
                        </td>
                        <td v-if="measures.hi_res=='off'" class="table-text-blocks text-right">
                            <b>{{ item.p | formatNumber }}</b>
                        </td>
                    </tr>
                </template>
            </v-simple-table>
            </v-row>
            <v-row no-gutters>
                <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                    <div v-if="precision_overflow" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                    <div v-if="addLoad_overflow" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla carico addizionale</b></div>
                </div>        
                <div class="d-flex flex-grow-0 flex-shrink-1 my-2">
                    <v-btn v-if="checkStatic && !preview" color="primary" @click="addRow"><v-icon class="pa-2">add_box</v-icon>aggiungi misura</v-btn>
                </div>
            </v-row>
            <v-row no-gutters class="d-flex justify-end">
                <div class="add_table text-center elevation-2 mb-4 mr-4">
                    <table class="pa-3">
                        <tr><td class="text-right">Carico da 1 a {{ measures.items.length }}</td><td class="text-right pl-2"><b>{{totalReading | formatNumber}}</b></td></tr>
                        <tr><td class="text-right">
                            <span v-if="measures.hi_res=='off'">Pmax - Pmin </span>
                            <span v-else>Imax - Imin </span></td><td class="text-right pl-2"><b>{{measures.diff | formatNumber}}</b>
                        </td></tr>
                        <tr><td class="text-right">Valore accettabile</td><td class="text-right pl-2"><b>{{measures.allowedError | formatNumber}}</b></td></tr>
                        <tr><td class="text-right">
                            ESITO:</td>
                            <td class="text-right pl-2">
                            <StatusIcon :status="measures.result" :tooltip_text="block_tooltip[measures.result]" />
                        </td></tr>
                    </table>
                </div>
            </v-row>
        </v-container>
        </div>
    </LayoutBlock>
</template>
<script>
import {zavorra_item} from "../../../utils/itemBlockSchema"
import {BaseLeg} from "../../../utils/baseLeg"
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from '../../../components/utils/StatusIcon'
import {uoms_conversion} from "../../../utils/commonUtils"
import Big from "big.js"

export default {
    components: {LayoutBlock, StatusIcon},
    mixins: [BaseLeg],
    data(){
        return {
            diff: 0,
            capacities: [
                {text: "20%", val: 0.20},
                {text: "35%", val: 0.35},
                {text: "50%", val: 0.50}
            ]
        }
    },
    computed: {
        notMechanical(){
            if(this.instrument_data && this.instrument_data.family == "bilancia nawi meccanica"){
                return false
            } else {
                return this.has_hi_res
            }
        },
        enoughPrimaries(){
            let maxRange = this.findMaxRange()
            let max = Big(maxRange.max)
            if(max.times(0.2).gt(this.calculateTotal)){
                return true
            } else {
                return false
            }
        },
        calculateTotal(){
            let sum = Big(0)
            if(this.data.primaries){
                for(let single of this.data.primaries){
                    if(single.family === "pesiera"){
                        let conv_factor = uoms_conversion[single.primary_data.data.uom][this.instrument_data.uom]
                        let refactored = Big(single.primary_data.data.weightTotal).times(conv_factor)
                        sum = sum.plus(refactored)
                    }
                }
            }
            return sum.toString()
        },
        computedCapacities(){
            let arr = []
            let max = Big(this.findMaxRange().max)
            let total = Big(this.calculateTotal)
            if(total.gte(max.times(0.2))){
                let item20 =  {text: "20%", val: 0.20}
                arr.push(item20)
            }
            if(total.gte(max.times(0.35))){
                let item35 =  {text: "35%", val: 0.35}
                arr.push(item35)
            }
            if(total.gte(max.times(0.5))){
                let item50 =  {text: "50%", val: 0.50}
                arr.push(item50)
            }
            return arr
        },
        
        totalReading(){
            let temp = Big(0);
            for(let item of this.measures.items){
                if(item.reading){
                    temp = temp.plus(item.reading)
                }
            }
            return this.round(temp);
        },
        checkResult(){
            if(this.data.reduced){
                if(this.measures && this.measures.result == "done"){
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        }
    },
    methods: {
        calcBlockResult() {
            let m_result = 'done'
            m_result = this.measures.items.reduce(function(result, item) {
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, 'done')
            let res = 'uncomplete'
            switch(m_result) {
                case 'uncomplete':
                    break
                case 'failed':
                    res = 'failed'
                    break
                case 'done':
                    if(this.precision_overflow || this.enoughPrimaries){
                        res = 'failed' 
                    } else  if(this.measures.hi_res == 'off' && this.addLoad_overflow ){
                        res = 'failed'
                    } else {
                        if(Big(this.measures.mass).gt(this.calculateTotal)){
                            res = 'failed'
                        } else {
                            res = Big(this.measures.diff).lte(this.measures.allowedError) ? 'done' : 'failed'
                        }
                    }
                    break
            }
            this.measures.result = res
        },
        
        changeMass() {
            if(this.measures.mass){
                for (var item of this.measures.items) {
                    item.mass = this.measures.mass;
                }
                if(this.measures.items && this.measures.items.length > 0){
                    this.measures.items[0].reading = this.measures.mass
                }
                this.measures.allowedError = this.calcAllowedError()
            }
        },
        addRow(){
            let item = zavorra_item({
                index: this.measures.items.length,
                mass: this.measures.mass
            })
            this.measures.items.push(item)
        },
     
        calcDiff(){
            let targets = [];
            for (let item of this.measures.items) {
                let t = 0
                if (this.measures.hi_res == 'off') {
                    t = item.p;
                } else {
                    t = item.reading;
                }
                targets.push(t)
            }
            let min = Math.min.apply(Math, targets);
            let max = Math.max.apply(Math, targets);
            this.measures.diff = this.differenceInt(max,min)
        },
    
        buildMeasures() {
            this.measures = {
                items: [],
                zero_device: this.conf.zero_device,
                hi_res: this.conf.hi_res,
                allowedError: 0,
                diff: 0,
                capacity: 0,
                mass: 0,
                result: 'uncomplete'
            }
            console.log("$$ building measures test")
            this.measures.hi_res = this.has_hi_res ? this.conf.hi_res : 'off'
            let currentRange = this.findMaxRange()
            this.measures.mass =  Big(currentRange.max).times(this.measures.capacity).div(100).toString()
            this.measures.allowedError = this.calcAllowedError()
            let item1 = zavorra_item({
                index: 1,
                mass: this.measures.mass,
                reading: this.measures.mass
            })
            this.measures.items.push(item1)
            for (let i = 1 ; i < this.conf.min_readings ; i++){
                this.addRow()
            }
            // console.log("BUILD MEASURES items", this.measures)
        },

        calcAllowedError(){
            let currRange = this.calcMinRange(this.measures.mass)
            let curr = Big(0)
            if(currRange){
                if(this.instrument_data.instrument_class){
                    curr = curr.plus(currRange.e)
                } else {
                    curr = curr.plus(currRange.d)
                }
            } 
            let range = this.findMaxRange()
            let mass = Big(this.measures.mass)
            let max = Big(range.max)
            if(mass.lt(max.times(0.2))){
                return -1
            } else if ( mass.lt(max.times(0.35))){
                return this.round(curr.times(0.2), this.high_precision)
            } else if ( mass.lt(max.times(0.5))){
                return this.round(curr.times(0.3), this.high_precision)
            } else {
                
                return this.round(this.calc_MPE(currRange, this.measures.mass), this.high_precision)
            }
        },

        changeCapacity(){
            let range = this.findMaxRange()
            this.measures.mass = Big(range.max).times(this.measures.capacity).toString()
            this.changeMass()
        },
        updateLinearity(){
            if(this.data.reduced){
                this.$emit('updateLinearity', {name: this.data.block.name, measures: this.measures})
            }
        },
        saveMeasures() {
            let block = this.data.block
            this.calcBlockResult()
            let testData = {capacity: this.measures.capacity, result: this.measures.result, mass: this.measures.mass, toUpdate: this.toUpdate}
            if(this.data.reduced && this.data.reduced == true){
                this.$emit('updateMeasures', {name: this.data.block.name, measures: this.measures, testData: testData})
            } else {
                this.data.common_data[block.name][block._id].value = testData
                this.$parent.$emit('updateMeasure', {b_index: this.data.b_index, measures: this.measures, p_idx: this.data.p_idx, p_id: this.data.p_id, common_data: this.data.common_data })
            }
        }
    },
  
}
</script>

